

















































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../lib/util";
import AbpBase from "../../lib/abpbase";
import Court from "../../store/entities/booking/court";
import Editor from "@tinymce/tinymce-vue";
import TinymceInit from "../../lib/TinymceInit";
import MultiPicture from "../../components/multi-picture.vue";
import RegionSelect from "../../components/region-select.vue";
//import { Survey } from "../../lib/tinymce-initial-value";
import Ajax from "@/lib/ajax";

TinymceInit.height = 300;

@Component({
  components: { Editor, MultiPicture, RegionSelect },
})
export default class CreateCourt extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;

  court: Court = new Court();
  list: any = [];
  targetKeys: any = [];
  tinymceInit = TinymceInit;
  titles = ["全部设施", "已选设施"];

  // survey = Survey;
  regions: any = [];
  mockData: any = [];
  selectedRegions: any = [];
  get extData() {
    return {
      courtId: this.court.id,
    };
  }
  handleChange(newTargetKeys) {
    this.targetKeys = newTargetKeys;
  }
  renderItem(item) {
    return item.label;
  }
  save() {
    (this.$refs.courtForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "court/createWithImages",
          data: {
            court: this.court,
            images: this.court.courtImages,
            courtFacilityAss: this.targetKeys,
          },
        });
        this.$Message.success({
          content:'添加球场成功'
        });
        (this.$refs.courtForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  async getAllList() {
    let res = await Ajax.get("/api/services/app/CourtInstallation/GetAllList");
    this.list = res.data.result;
    let mockData = [];
    for (let i = 0; i < this.list.length; i++) {
      mockData.push({
        key: this.list[i].value.toString(),
        label: this.list[i].label,
      });
    }
    this.mockData = mockData;
  }
  cancel() {
    (this.$refs.courtForm as any).resetFields();
    this.$emit("input", false);
  }

  async visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      await this.getAllList();
    }
  }
  async validateRegionId(rule, value, callback) {
    if (!value) {
      callback(new Error("请选择地区"));
    }
  }
  async validateTunnelNumber(rule, value, callback) {
    if (!value) {
      callback(new Error("请输入球场洞数"));
    }
  }
  async validatePpeningTime(rule, value, callback) {
     if (!this.court.openingTime) {
      callback(new Error("请选择开业时间"));
    }
  }
   async validateDistance(rule, value, callback) {
    if (!value) {
      callback(new Error("请输入距离"));
    }
  }
  async validateCourtImages(rule, value, callback) {
    if (value.length == 0) {
      callback(new Error("请上传球场图片"));
    }
  }
  courtRule = {
    name: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("CourtName")),
        trigger: "blur",
      },
      {
        type: "string",
        max: 256,
        message: this.L(
          "NoMoreThenLength",
          undefined,
          this.L("CourtName"),
          "256"
        ),
        trigger: "blur",
      },
    ],
    address: [
      {
        required: true,
        type: "string",
        max: 512,
        message: this.L(
          "NoMoreThenLength",
          undefined,
          this.L("Address"),
          "512"
        ),
        trigger: "blur",
      },
    ],
    // tunnelNumber: [
    //   {
    //     required: true,
    //     type: "number",
    //     validator: this.validateTunnelNumber,
    //     message: "请输入洞数",
    //     trigger: "blur change",
    //   },
    // ],
    // par: [
    //   {
    //     required: true,
    //     type: "string",
    //     message: "请输入标准杆",
    //     trigger: "blur",
    //   },
    // ],
    // distance: [
    //   {
    //     required: true,
    //     type: "number",
    //     validator: this.validateDistance,
    //     message: "请输入距离",
    //     trigger: "blur change",
    //   },
    // ],
    // greenSpecies: [
    //   {
    //     required: true,
    //     type: "string",
    //     message: "请输入果岭草种",
    //     trigger: "blur",
    //   },
    // ],
    // fairwaySpecies: [
    //   {
    //     required: true,
    //     type: "string",
    //     message: "请输入球道草种",
    //     trigger: "blur",
    //   },
    // ],
    // courtStyle: [
    //   {
    //     required: true,
    //     type: "string",
    //     message: "请输入风格",
    //     trigger: "blur",
    //   },
    // ],
    // designer: [
    //   {
    //     required: true,
    //     type: "string",
    //     message: "请输入设计师",
    //     trigger: "blur",
    //   },
    // ],
    openingTime: [
      {
        required: true,
        validator: this.validatePpeningTime,
        message: "选择开业时间",
        trigger: "change",
      },
    ],
    phoneNumber: [
      {
        required: true,
        type: "string",
        message: "请输入手机号",
        trigger: "blur",
      },
    ],
    installations: [
      {
        required: true,
        // pattern: /^([+-]?)\d*\.\d+$/,
        message: "请填写球场设施",
        trigger: "blur",
      },
    ],
    regionId: [
      {
        required: true,
        validator: this.validateRegionId,
        trigger: "change",
      },
    ],
    // longitude: [
    //   {
    //     required: true,
    //     // pattern: /^([+-]?)\d*\.\d+$/,
    //     message: "请填写经度",
    //     trigger: "blur",
    //   },
    // ],
    // latitude: [
    //   {
    //     required: true,
    //     // pattern: /^([+-]?)\d*\.\d+$/,
    //     message: "请填写纬度",
    //     trigger: "blur",
    //   },
    // ],
    courtImages: [
      {
        required: true,
        validator: this.validateCourtImages,
        trigger: "change",
      },
    ],
  };
}
